module.exports = __webpack_public_path__ + "static/media/YF81_1.e598fc1b.jpg";